import {
  useAPIGetPelaksanaanPSList,
  useAPIGetPelaksanaanPSListSummary,
} from 'api/kinerja/tim-penilai-ps/pelaksanaan'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

import type { PelaksanaanPSListFilterState } from 'types/kinerja-tim-penilai-ps'

export default function usePelaksanaanList({
  filter,
}: {
  filter: PelaksanaanPSListFilterState
}) {
  const {
    isPPKPengawasSekolah,
    isTimKinerjaPengawasSekolah,
    isProfilePSPegawaiFetched,
  } = useRoleContext()

  const {
    data: summary,
    isLoading: isSummaryLoading,
    isFetched: isSummaryFetched,
  } = useAPIGetPelaksanaanPSListSummary({
    enabled:
      isProfilePSPegawaiFetched &&
      (isPPKPengawasSekolah || isTimKinerjaPengawasSekolah),
  })

  const {
    data,
    isLoading: isListLoading,
    isFetched: isListFetched,
  } = useAPIGetPelaksanaanPSList({
    filter,
    enabled:
      isProfilePSPegawaiFetched &&
      (isPPKPengawasSekolah || isTimKinerjaPengawasSekolah),
  })

  return {
    data,
    summary,
    isLoading: isListLoading || isSummaryLoading,
    isFetched: isListFetched && isSummaryFetched,
  }
}
